<template>
  <a-layout class='index animated fadeIn'>
    <a-card :bordered='false'>
      <a-spin :spinning="loading">
        <a-form ref="ruleForm" :model="form" :rules="rules" :label-col="labelCol" :wrapper-col="wrapperCol">
          <a-form-item ref="name" label="" name="name">
            <div class="s_flex_ali">
              <div class="s_flex_ali width17 m-r-15">
                <a-checkbox v-model:checked="form.is_credit_points" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">单笔核销积分满</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.credit_points" style="width:100%" placeholder='请输入' :min='1' :precision='0' :disabled="!form.is_credit_points" />
              </div>
              <div class="m-r-15">
                <p>积分，增加1成长值</p>
              </div>
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    店长或店员核销积分，单笔核销积分达到设定积分值，可获得1成长值，一笔核销积分最多获得1成长值。
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <a-form-item ref="name" label="" name="name">
            <div class="s_flex_ali">
              <div class="s_flex_ali width17 m-r-15">
                <a-checkbox v-model:checked="form.is_cloud_order_amount" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">云店订单累计满</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.cloud_order_amount" style="width:100%" placeholder='请输入' :min='1' :precision='2' :disabled="!form.is_cloud_order_amount" />
              </div>
              <div class="m-r-15">
                <p>元，增加1成长值</p>
              </div>
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    消费者在云店中购买商品（购买形式不限，如：普通购物、秒杀购物、拼团购物等），订单金额累计金额满足设置金额，增加1成长值，金额可多单累计。
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <a-form-item ref="name" label="" name="name">
            <div class="s_flex_ali">
              <div class="s_flex_ali width17 m-r-15">
                <a-checkbox v-model:checked="form.is_invitation_distributor" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">成功邀请</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.invitation_distributor" style="width:100%" placeholder='请输入' :min='1' :precision='0' :disabled="!form.is_invitation_distributor" />
              </div>
              <div class="m-r-15">
                <p>名分销员，增加1成长值</p>
              </div>
              
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    通过邀请海报，累计成功邀请设定分销员数量，增加1成长值，门店分销员成功邀请下级分销员也计算在内。
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <a-form-item ref="name" label="" name="name">
            <div class="s_flex_ali">
              <div class="s_flex_ali width17 m-r-15">
                <a-checkbox v-model:checked="form.is_confirm_out_warehousing_code_num" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">签收的出库单中商品累计满</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.confirm_out_warehousing_code_num" style="width:100%" placeholder='请输入' :min='1' :precision='0' :disabled="!form.is_confirm_out_warehousing_code_num" />
              </div>
              <div class="m-r-15">
                <p>件，增加1成长值</p>
              </div>
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    门店通过智能防窜功能，签收的出库单中商品累计达到设定数量，增加1成长值，商品数量可多单累计。
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <a-form-item ref="name" label="" name="name">
            <div class="s_flex_ali">
              <div class="s_flex_ali width17 m-r-15">
                <a-checkbox v-model:checked="form.is_extension_store_num" @change="onChange"></a-checkbox>
                <p class="s_c333 m-l-10">邀请门店累计满</p>
              </div>
              <div class="width40 m-r-15">
                <a-input-number v-model:value="form.extension_store_num" style="width:100%" placeholder='请输入' :min='1' :precision='0' :disabled="!form.is_extension_store_num" />
              </div>
              <div class="m-r-15">
                <p>家，增加1成长值</p>
              </div>
              <div>
                <a-tooltip placement="right">
                  <template #title>
                    门店在门店后台-推广门店中累计推荐达到设定数量门店，增加1成长值，推广门店成功邀请门店不计算在内。
                  </template>
                  <QuestionCircleOutlined class="s_c376" />
                </a-tooltip>
              </div>
            </div>
          </a-form-item>
          <a-form-item :wrapper-col="{ span: 8, offset: 2 }">
            <a-button style="width:100px" type="primary" v-has:storeLevelSetup="onSubmit">
              保存
            </a-button>
          </a-form-item>
        </a-form>
      </a-spin>
    </a-card>
  </a-layout>
</template>
<script>
  import { QuestionCircleOutlined } from "@ant-design/icons-vue";
  import { ref, onMounted, reactive, toRefs, inject } from 'vue';
  import { message } from 'ant-design-vue';
  import { setStorePurchase, getStorePurchase } from "@/api/store";
  import { iscode } from "@/utils/app";
  // 初始化默认筛选项数值
  let defForm = {
    credit_points: 0,
    cloud_order_amount: 0,
    invitation_distributor: 0,
    confirm_out_warehousing_code_num: 0,
    extension_store_num: 0,
    is_credit_points: 0,
    is_cloud_order_amount: 0,
    is_invitation_distributor: 0,
    is_confirm_out_warehousing_code_num:0,
    is_extension_store_num:0
  }
  export default {
    name: 'setUp',
    components: {
      QuestionCircleOutlined
    },
    setup() {
      const form = ref({ ...defForm });
      const state = reactive({
        labelCol: { span: 2 },
        wrapperCol: { span: 22 },
        loading: false
      });
      const getMore = async () => {
        state.loading = true
        let res = await getStorePurchase().then(res => res.data);
        if (iscode(res)) {
          form.value = res.data;
          state.loading = false
        } else {
          message.info(res.msg);
          state.loading = false
        }
      }
      getMore();
      const ruleForm = ref()
      const onSubmit = () => {
        ruleForm.value.validate().then(async () => {
          const hide = message.loading('正在加载中...', 0);
          let res = await setStorePurchase({
            ...form.value,
            is_credit_points: form.value.is_credit_points ? 1 : 0,
            is_cloud_order_amount: form.value.is_cloud_order_amount ? 1 : 0,
            is_invitation_distributor: form.value.is_invitation_distributor ? 1 : 0,
            is_confirm_out_warehousing_code_num: form.value.is_confirm_out_warehousing_code_num ? 1 : 0,
            is_extension_store_num: form.value.is_extension_store_num ? 1 : 0
          }).then(res => res.data);
          if (iscode(res)) {
            setTimeout(hide);
            message.success(res.msg);
            getMore();
          } else {
            setTimeout(hide);
            message.error(res.msg);
          }
        }).catch(error => {
          message.error('请完善表单！');
        });
      }
      return {
        form,
        ...toRefs(state),
        ruleForm,
        onSubmit,
        getMore
      }
    }
  }
</script>
